document.addEventListener("DOMContentLoaded", async function() {

    $('body').on('click', '[data-show-more]', function() {
        const parentEle = $(this).closest('.two_column_labels');
        parentEle.find('.show-more-container').addClass('is_hide');
        parentEle.find('.show-less-container').removeClass('is_hide');
        parentEle.find('.filter_swatch.hidden-filter').removeClass('force-hide2');
    })

    $('body').on('click', '[data-show-less]', function() {
        const parentEle = $(this).closest('.two_column_labels');
        parentEle.find('.show-less-container').addClass('is_hide');
        parentEle.find('.show-more-container').removeClass('is_hide');
        parentEle.find('.filter_swatch.hidden-filter').addClass('force-hide2');
    })

    $('body').on('change', 'input.bundle-builder__toggle-input', async function() {
        $('.bundle-builder__category--level-1').removeClass('active_level');
        const $parent = $(this).closest('.bundle-builder__categories');
        const levelFirst = $parent.find('.bundle-builder__category--level-1').first();
        const levelSecound = $parent.find('.bundle-builder__category--level-1').last();
        
        let activeLevelOne = levelFirst.attr('data-handle');
        if ($(this).prop('checked')) {
            levelSecound.addClass('active_level');
            activeLevelOne = levelSecound.attr('data-handle');
        } else {
            levelFirst.addClass('active_level');
            activeLevelOne = levelFirst.attr('data-handle');
        }
        
        $(`.bundle-builder__level-2`).removeClass('active_level');
        const levelTwo = $(`.bundle-builder__level-2[data-parent="${activeLevelOne}"]`);
        if (!levelTwo.length) return;

        levelTwo.addClass('active_level');
        levelTwo.find('.bundle-builder__category--level-2').removeClass('active_level');
        levelTwo.find('.bundle-builder__category--level-2').first().addClass('active_level');
        let activeLevelTwo = levelTwo.find('.bundle-builder__category--level-2').first().attr('data-handle');
        
        $(`.bundle-builder__level-3`).removeClass('active_level');
        const levelThrid = $(`.bundle-builder__level-3[data-parent-one="${activeLevelOne}"][data-parent-two="${activeLevelTwo}"]`);
        if (!levelThrid.length) return;
        
        levelThrid.addClass('active_level');    
        levelThrid.find('.bundle-builder__category--level-3').removeClass('active_level');
        levelThrid.find('.bundle-builder__category--level-3').first().addClass('active_level');
        await fetchCollection();
    })

    $('body').on('click', '.bundle-builder__category--level-2', async function() {
        $(`.bundle-builder__category--level-2`).removeClass('active_level');
        $(this).addClass('active_level');
        const parentEle = $(this).closest('.bundle-builder__level-2');
        if (!parentEle.length) return;

        let activeLevelOne = parentEle.attr('data-parent'); 
        let activeLevelTwo = $(this).attr('data-handle'); 

        $(`.bundle-builder__level-3`).removeClass('active_level');
        const levelThrid = $(`.bundle-builder__level-3[data-parent-two="${activeLevelTwo}"]`);
        if (!levelThrid.length) return;
        
        levelThrid.addClass('active_level');
        levelThrid.find('.bundle-builder__category--level-3').removeClass('active_level');
        levelThrid.find('.bundle-builder__category--level-3').first().addClass('active_level');
        await fetchCollection();
    })

    $('body').on('click', '.bundle-builder__category--level-3', async function() {
        $(`.bundle-builder__category--level-3`).removeClass('active_level');
        $(this).addClass('active_level');
        await fetchCollection();
    })


    function addOrUpdateViewParam(url, template) {
        if (!template) return url;
        const [baseWithQuery, hash] = url.split('#');
        const hasQuery = baseWithQuery.includes('?');
        const separator = hasQuery ? '&' : '?';
        const newUrl = `${baseWithQuery}${separator}view=${encodeURIComponent(template)}`;
        return hash ? `${newUrl}#${hash}` : newUrl;
    }

    async function fetchCollection() {
        $('body').addClass('pointer-events-none');
        $('.body-loader').addClass('active');
        let $levelThreeEle = $('.bundle-builder__level-3.active_level')
            .find('.bundle-builder__category--level-3.active_level');

        let collectionUrl = $levelThreeEle.attr('data-parent-third-url');

        if (!$levelThreeEle.length) {
            $levelThreeEle = $('.bundle-builder__level-3.active_level');
            collectionUrl = $levelThreeEle.attr('data-parent-two-url');
        }

        if (!collectionUrl) return;

        const template = $('.bundle-builder__categories').attr('data-template');
        collectionUrl = addOrUpdateViewParam(collectionUrl, template);
        // const updatedStateObject = { filter: 'active' };
        // const updatedTitle = 'Products Active Filter';

        // window.history.replaceState(updatedStateObject, updatedTitle, collectionUrl);
        // history.pushState({ collectionUrl }, '', `${collectionUrl}`);
        try {
            $('.bundle-builder__categories').attr('data-collection', collectionUrl);
            const responseHTML = await $.ajax({
                url: collectionUrl,
                method: 'GET',
                dataType: 'html',
            });

            const $newContent = $(responseHTML).find('#main-collection-product-grid');
            $('#main-collection-product-grid').html($newContent.html());

            const $newFilterForm = $(responseHTML).find('#CollectionFiltersForm');
            if ($newFilterForm && $newFilterForm.length) {
                $('#CollectionFiltersForm').html($newFilterForm.html());
            }

            const $newFilterHead = $(responseHTML).find('#CollectionProductFiltersHead');
            if ($newFilterHead && $newFilterHead.length) {
                $('#CollectionProductFiltersHead').html($newFilterHead.html());
            }

            const $newFilterSidebar = $(responseHTML).find('[data-collection-sidebar-filters]');
            if ($newFilterSidebar && $newFilterSidebar.length) {
                $('[data-collection-sidebar-filters]').html($newFilterSidebar.html());
            }

            const $newFilterAside = $(responseHTML).find('.js-col-filter-sidebar');
            if ($newFilterAside && $newFilterAside.length) {
                $('.js-col-filter-sidebar').html($newFilterAside.html());
            }

            const $newFilter = $(responseHTML).find('#CollectionProductFilters'); 
            if ($newFilter && $newFilter.length) {
                $('#CollectionProductFilters').html($newFilter.html());
            }       
        
            const syntheticEvent = new Event("CollectionUpdated", {
                bubbles: true,
                cancelable: false
            });
            document.dispatchEvent(syntheticEvent);
            
            $('.body-loader').removeClass('active');
            $('body').removeClass('pointer-events-none');
            
        } catch (err) {
            console.error('fetchCollection failed:', err);
            throw err;
        }
        
        $('.body-loader').removeClass('active');
        $('body').removeClass('pointer-events-none');
    }



    await fetchCollection();


    
    $('body').on('click', '.js-collection-side-filter, .js-current-filter', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        const filterURL = $(this).attr('href');
        if (!filterURL) return;
        try {
            $('body').addClass('pointer-events-none');
            $('.body-loader').addClass('active');
            $('.bundle-builder__categories').attr('data-collection', filterURL);
            const responseHTML = await $.ajax({
                url: filterURL,
                method: 'GET',
                dataType: 'html',
            });

            const $newContent = $(responseHTML).find('#main-collection-product-grid');
            $('#main-collection-product-grid').html($newContent.html());

            const $newFilterForm = $(responseHTML).find('#CollectionProductFiltersHead');
            if ($newFilterForm && $newFilterForm.length) {
                $('#CollectionProductFiltersHead').html($newFilterForm.html());
            }

            const $newFilterSidebar = $(responseHTML).find('[data-collection-sidebar-filters]');
            if ($newFilterSidebar && $newFilterSidebar.length) {
                $('[data-collection-sidebar-filters]').html($newFilterSidebar.html());
            }

            const $newFilterAside = $(responseHTML).find('.js-col-filter-sidebar');
            if ($newFilterAside && $newFilterAside.length) {
                $('.js-col-filter-sidebar').html($newFilterAside.html());
            }

            const $newFilter = $(responseHTML).find('#CollectionProductFilters'); 
            if ($newFilter && $newFilter.length) {
                $('#CollectionProductFilters').html($newFilter.html());
            }       
        
            const syntheticEvent = new Event("CollectionUpdated", {
                bubbles: true,
                cancelable: false
            });
            document.dispatchEvent(syntheticEvent);
            
            $('.body-loader').removeClass('active');
            $('body').removeClass('pointer-events-none');
            
        } catch (err) {
            console.error('fetchCollection failed:', err);
            throw err;
        }
        
        $('.body-loader').removeClass('active');
        $('body').removeClass('pointer-events-none');
    })

    $('body').on('click', '.js-hz-filter-list li', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        let sortBy = $(this).find('input').val();
        if (!sortBy) return;
        let sortByPlaceholder = $(this).attr('data-placeholder');
        let filterURL = $('.bundle-builder__categories').attr('data-collection');
        if (!filterURL) return;
        const baseUrl = window.location.origin;
        const newUrl = new URL(baseUrl+filterURL);
        newUrl.searchParams.set('sort_by', sortBy);
                
        try {
            $('body').addClass('pointer-events-none');
            $('.body-loader').addClass('active');
            $('.bundle-builder__categories').attr('data-collection', filterURL);
            const responseHTML = await $.ajax({
                url: newUrl.href,
                method: 'GET',
                dataType: 'html',
            });

            const $newContent = $(responseHTML).find('#main-collection-product-grid');
            $('#main-collection-product-grid').html($newContent.html());

            const $newFilterForm = $(responseHTML).find('#CollectionProductFiltersHead');
            if ($newFilterForm && $newFilterForm.length) {
                $('#CollectionProductFiltersHead').html($newFilterForm.html());
            }

            const $newFilter = $(responseHTML).find('#CollectionProductFilters'); 
            if ($newFilter && $newFilter.length) {
                $('#CollectionProductFilters').html($newFilter.html());
            }       
        
            const syntheticEvent = new Event("CollectionUpdated", {
                bubbles: true,
                cancelable: false
            });
            // document.dispatchEvent(syntheticEvent);
            if(sortByPlaceholder) $('.collection__filtering .chosen-value').attr('placeholder', sortByPlaceholder);
            $('.body-loader').removeClass('active');
            $('body').removeClass('pointer-events-none');
            
        } catch (err) {
            console.error('fetchCollection failed:', err);
            throw err;
        }
        
        $('.body-loader').removeClass('active');
        $('body').removeClass('pointer-events-none');
    })


    $('body').on('change', 'select.bundle-card__select', function() {
        const parent = $(this).closest('.bundle-builder__card');
        if (!parent.length) return;
        let option1 = null, option2 = null, option3 = null, selectedOption = null;
        if (parent.find('select.bundle-card__select[name="option1"]')) {
            option1 = parent.find('select.bundle-card__select[name="option1"]').val();
        }
        if (parent.find('select.bundle-card__select[name="option2"]')) {
            option2 = parent.find('select.bundle-card__select[name="option2"]').val();
        }
        if (parent.find('select.bundle-card__select[name="option3"]')) {
            option3 = parent.find('select.bundle-card__select[name="option3"]').val();
        }

        if (option1 && option2 && option3) {
            selectedOption = parent.find(`select.variant__select[name="variant"] option[data-option1="${option1}"][data-option2="${option2}"][data-option3="${option3}"]`);
        } else if (option1 && option2) {
            selectedOption = parent.find(`select.variant__select[name="variant"] option[data-option1="${option1}"][data-option2="${option2}"]`);
        } else if (option1) {
            selectedOption = parent.find(`select.variant__select[name="variant"] option[data-option1="${option1}"]`);
        }
        
        if (selectedOption) {
            const variantId = selectedOption.attr('value');
            const variantTitle = selectedOption.attr('data-title');
            const price = selectedOption.attr('data-price');
            const priceCompare = selectedOption.attr('data-compare-price');
            const priceMoney = selectedOption.attr('data-price-money');
            const priceCompareMoney = selectedOption.attr('data-compare-price-money');
            const available = selectedOption.attr('data-available');
            const addToCartBtn = parent.find('#CardAddToCart');

            if (available == 'true' && addToCartBtn) {
                addToCartBtn.html('Add to Bundle');
                addToCartBtn.prop('disabled', false);
            } else if (addToCartBtn) {
                addToCartBtn.html('Sold Out');
                addToCartBtn.prop('disabled', true);
            }

            const priceEle = parent.find('.bundle-card__price--sale');
            const priceCompareEle = parent.find('.bundle-card__price--compare');

            if (variantTitle && addToCartBtn) {
                addToCartBtn.attr('data-variant-title', variantTitle);
            }
            if (priceMoney && priceEle) {
                priceEle.html(priceMoney);
            }
            if (priceCompareMoney && priceCompareEle) {
                priceCompareEle.html(priceCompareMoney);
            }
            if (variantId && addToCartBtn) {
                addToCartBtn.attr('data-variant-id', variantId);
            }
            
            if (price && addToCartBtn) {
                addToCartBtn.attr('data-variant-price', price);
            }
            
            if (priceCompare && addToCartBtn) {
                addToCartBtn.attr('data-variant-compare', priceCompare);
            }

        }
    })

$('body').on('click', '#CardAddToCart', function (e) {
  e.preventDefault();
  const variantId = $(this).attr('data-variant-id');
  const productTitle = $(this).attr('data-product-title');
  const variantOption = $(`select.variant__select option[value="${variantId}"]`);
  if (!variantOption.length) return;
  const variantTitle = variantOption.attr('data-title');
  const variantPrice = variantOption.attr('data-price');
  const variantCompare = variantOption.attr('data-compare-price');
  const variantPriceMoney = variantOption.attr('data-price-money');
  const variantCompareMoney = variantOption.attr('data-compare-price-money');
  const variantImg = variantOption.attr('data-img');
  const variantAvailable = variantOption.attr('data-available');
  
  const selectedCollection = ($('.bundle-builder__category--level-2.active_level').attr('data-handle') || '').toLowerCase();
  const normalize8 = (str) => (str.length > 8 ? str.slice(0, 8) : str);

  const selectedKey = normalize8(selectedCollection);

  $('.bundle-builder__sidebar .bundle-builder__progress-step').each(function () {
    const stepHandle = ($(this).attr('data-product') || '').toLowerCase();
    const stepKey = normalize8(stepHandle);
    if (selectedKey === stepKey) {
      $(this).addClass('added');
      return false;
    }
  });

  $('.bundle-builder__sidebar .bundle-builder__item').each(function () {
    const stepHandle = ($(this).attr('data-product') || '').toLowerCase();
    const stepKey = normalize8(stepHandle);
    if (selectedKey === stepKey) {
        $(this).attr('data-variant', variantId);
        $(this).attr('data-price', variantPrice);
        $(this).attr('data-compare-price', variantCompare);
        $(this).find('.bundle-item__image img').attr('src', variantImg);
        $(this).find('.bundle-item__title h4').html(productTitle);
        $(this).find('.bundle-item__price.bundle-item__price--sale').html(variantPriceMoney);
        $(this).find('.bundle-item__price.bundle-item__price-compare').html(variantCompareMoney);
        $(this).find('.bundle-item__variant span').html(variantTitle);
        $(this).addClass('active_card');
        if($('.bundle-builder__progress-step.added').length == 3) {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '1');
        } else if ($('.bundle-builder__progress-step.added').length == 2) {
            if ($('.bundle-builder__progress-step[data-product="top"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added')) {
                $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
                $('.bundle-builder__summary-progress__bar span.first_half').css('opacity', '1');
            } else if ($('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="accessory"]').hasClass('added')) {
                $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
                $('.bundle-builder__summary-progress__bar span.second_half').css('opacity', '1');
            } else {
                $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
            }
        } else {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
        }

        updateBundlePrice();
        return false;
    }
  });

});

$('body').on('click', '#RemoveBundleItem', function (e) {
  e.preventDefault();
    const parentEle = $(this).closest('.bundle-builder__item');
    parentEle.removeClass('active_card');
    const collectionHandle = parentEle.attr('data-product');
    const variantImg = parentEle.find('.bundle-item__image img').attr('data-src');
    parentEle.attr('data-variant', '');
    parentEle.attr('data-price', '');
    parentEle.attr('data-compare-price', '');
    parentEle.find('.bundle-item__image img').attr('src', variantImg);
    parentEle.find('.bundle-item__price.bundle-item__price--sale').html('');
    parentEle.find('.bundle-item__price.bundle-item__price-compare').html('');
    parentEle.find('.bundle-item__variant span').html('');
    $(`.bundle-builder__progress-step[data-product="${collectionHandle}"]`).removeClass('added');
    
    if($('.bundle-builder__progress-step.added').length == 3) {
        $('.bundle-builder__summary-progress__bar span').css('opacity', '1');
    } else if ($('.bundle-builder__progress-step.added').length == 2) {
        if ($('.bundle-builder__progress-step[data-product="top"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added')) {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
            $('.bundle-builder__summary-progress__bar span.first_half').css('opacity', '1');
        } else if ($('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="accessory"]').hasClass('added')) {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
            $('.bundle-builder__summary-progress__bar span.second_half').css('opacity', '1');
        } else {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
        }
    } else {
        $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
    }

    updateBundlePrice();
});

function updateBundlePrice () {
    let totalPrice = 0;
    let totalComparePrice = 0;
    $('.bundle-builder__sidebar .bundle-builder__item.active_card').each(function () {
        totalPrice += parseInt($(this).attr('data-price'));
        totalComparePrice += parseInt($(this).attr('data-compare-price'));
    });
    if (totalPrice != 0) {
        $('.bundle-builder__price-before span').html(theme.Helpers.formatMoney(totalPrice));
    }

    var addedCount = $('.bundle-builder__sidebar .bundle-builder__progress-step.added').length;

    // Find the applicable discount based on min_prod
    var applicableDiscount = 0;
    var ruleMatched = false;
    bundleDiscountRules.forEach(function(rule) {
      if (addedCount >= rule.min_prod && rule.discount > applicableDiscount) {
        applicableDiscount = rule.discount;
        ruleMatched = true;
      }
    });

    // Calculate price after discount
    var priceAfterDiscount = totalPrice - (totalPrice * applicableDiscount / 100);

    // Update UI
    if (!ruleMatched || addedCount <= 1) {
        $('button#BundleAddToCart').prop('disabled', true);
        $('.bundle-builder__pricing .total_compare_price_bundle').hide();
        $('.bundle-builder__pricing .total_save_price_bundle').hide();
        $('.bundle-builder__price-current span').html(theme.Helpers.formatMoney(totalPrice));
        $('.bundle-builder__savings span').html("0%");
    } else {
        // Enable button if at least one discount applies
        $('button#BundleAddToCart').prop('disabled', false);
        $('.bundle-builder__price-current span').html(theme.Helpers.formatMoney(priceAfterDiscount));
        $('.bundle-builder__savings span').html(applicableDiscount + "%");
        $('.bundle-builder__pricing .total_compare_price_bundle').css('display', 'flex');
        $('.bundle-builder__pricing .total_save_price_bundle').css('display', 'flex');
    }

}

// document.addEventListener("CollectionUpdated", function(){
//     console.log('CollectionUpdated');
//     const activeCollection = $('.bundle-builder__category--level-2.active_level').attr('data-handle');
//     $('.bundle-builder__sidebar .bundle-builder__item.active_card').each(function () {
//         const activeCard = $(this).attr('data-product');
//     });
// });

function generateUID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

$('body').on('click', 'button#BundleAddToCart:not([disabled])', async function(e) {
    e.preventDefault();
    $(this).prop('disabled', true);
    $(this).html('Adding Bundle...');
    let bundleData = [];
    let set_id = generateUID();
    $('.bundle-builder__sidebar .bundle-builder__item.active_card').each(function () {
        let bundleItem = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
        bundleItem["properties"] = {
            '_bundled-product': true,
            '_set_id': set_id
        };
        bundleData.push(bundleItem);
    });

    if (bundleData.length > 0) {
        try {
            const response = await fetch(`/cart/add.js`, {
                body: JSON.stringify({ items: bundleData }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });
            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }

            if(response.ok) {
              const event = new Event('cart:show');
              document.dispatchEvent(event);
            } else {
              alert('Could not add items. Please try again later.')
            }
            $('button#RemoveBundleItem').each(function () {
                $(this).click();
            });

            $(this).prop('disabled', false);
            $(this).html('Add Bundle to Cart');

        } catch (err) {
            console.error('fetchCollection failed:', err);
            throw err;
        }
        
        $(this).prop('disabled', false);
        $(this).html('Add Bundle to Cart');
    }
});


// Sync Price slider <-> Min/Max inputs (works with dynamic HTML using event delegation)

  function getEls($wrap) {
    return {
      $minInput:  $wrap.find('.js-price-min-output'),
      $maxInput:  $wrap.find('.js-price-max-output'),
      $minSlider: $wrap.find('.filter-range__slider--input').eq(0),
      $maxSlider: $wrap.find('.filter-range__slider--input').eq(1)
    };
  }

  function clamp(v, min, max) {
    v = parseFloat(v);
    if (isNaN(v)) v = min;
    return Math.min(Math.max(v, min), max);
  }

  function setValues($wrap, minVal, maxVal) {
    const els = getEls($wrap);
    if (!els.$minInput.length || !els.$maxInput.length || !els.$minSlider.length || !els.$maxSlider.length) return;

    const MIN = parseFloat(els.$minSlider.attr('min')) || 0;
    const MAX = parseFloat(els.$minSlider.attr('max')) || 0;

    minVal = clamp(minVal, MIN, MAX);
    maxVal = clamp(maxVal, MIN, MAX);

    if (minVal > maxVal) minVal = maxVal;

    els.$minInput.val(minVal);
    els.$maxInput.val(maxVal);
    els.$minSlider.val(minVal);
    els.$maxSlider.val(maxVal);

    const priceFilter = {'minVal': minVal, 'maxVal': maxVal}
    return priceFilter;
  }

  // Slider -> Inputs (dynamic)
  $('body').on('input change', '[data-collection-filters-price-range] .filter-range__slider--input', async function (e) {
    e.preventDefault();
    const $wrap = $(this).closest('[data-collection-filters-price-range]');
    const els = getEls($wrap);

    const minVal = els.$minSlider.val();
    const maxVal = els.$maxSlider.val();

    const priceFilter = setValues($wrap, minVal, maxVal);
    const collectionUrl = $wrap.attr('data-collection');
    const baseUrl = window.location.origin;
    let newUrl = new URL(baseUrl+collectionUrl);

    const activeFilter = $('#CollectionSidebarFiltersForm .current.filter_swatch').first();
    if (activeFilter && activeFilter.length && activeFilter.attr('data-url')) {        
        newUrl = new URL(baseUrl+activeFilter.attr('data-url'));
    }

    newUrl.searchParams.set('filter.v.price.gte', priceFilter.minVal);
    newUrl.searchParams.set('filter.v.price.lte', priceFilter.maxVal);
    // console.log('newUrl', newUrl);
    

        try {
            $('body').addClass('pointer-events-none');
            $('.body-loader').addClass('active');
            $('.bundle-builder__categories').attr('data-collection', newUrl);
            const responseHTML = await $.ajax({
                url: newUrl,
                method: 'GET',
                dataType: 'html',
            });

            const $newContent = $(responseHTML).find('#main-collection-product-grid');
            $('#main-collection-product-grid').html($newContent.html());

            const $newFilterForm = $(responseHTML).find('#CollectionProductFiltersHead');
            if ($newFilterForm && $newFilterForm.length) {
                $('#CollectionProductFiltersHead').html($newFilterForm.html());
            }

            const $newFilterSidebar = $(responseHTML).find('[data-collection-sidebar-filters]');
            if ($newFilterSidebar && $newFilterSidebar.length) {
                $('[data-collection-sidebar-filters]').html($newFilterSidebar.html());
            }

            const $newFilterAside = $(responseHTML).find('.js-col-filter-sidebar');
            if ($newFilterAside && $newFilterAside.length) {
                $('.js-col-filter-sidebar').html($newFilterAside.html());
            }

            const $newFilter = $(responseHTML).find('#CollectionProductFilters'); 
            if ($newFilter && $newFilter.length) {
                $('#CollectionProductFilters').html($newFilter.html());
            }       
        
            const syntheticEvent = new Event("CollectionUpdated", {
                bubbles: true,
                cancelable: false
            });
            document.dispatchEvent(syntheticEvent);
            
            $('.body-loader').removeClass('active');
            $('body').removeClass('pointer-events-none');
            
        } catch (err) {
            console.error('fetchCollection failed:', err);
            throw err;
        }
        
        $('.body-loader').removeClass('active');
        $('body').removeClass('pointer-events-none');
  });

  // Inputs -> Slider (dynamic)
  $('body').on('input change', '[data-collection-filters-price-range] .js-price-min-output, [data-collection-filters-price-range] .js-price-max-output', async function (e) {
    e.preventDefault();
    const $wrap = $(this).closest('[data-collection-filters-price-range]');
    const els = getEls($wrap);

    const priceFilter = setValues($wrap, els.$minInput.val(), els.$maxInput.val());
    const collectionUrl = $wrap.attr('data-collection');
    const baseUrl = window.location.origin;
    let newUrl = new URL(baseUrl+collectionUrl);

    const activeFilter = $('#CollectionSidebarFiltersForm .current.filter_swatch').first();
    if (activeFilter && activeFilter.length && activeFilter.attr('data-url')) {        
        newUrl = new URL(baseUrl+activeFilter.attr('data-url'));
    }

    newUrl.searchParams.set('filter.v.price.gte', priceFilter.minVal);
    newUrl.searchParams.set('filter.v.price.lte', priceFilter.maxVal);
    // console.log('newUrl', newUrl);
    

        try {
            $('body').addClass('pointer-events-none');
            $('.body-loader').addClass('active');
            $('.bundle-builder__categories').attr('data-collection', newUrl);
            const responseHTML = await $.ajax({
                url: newUrl,
                method: 'GET',
                dataType: 'html',
            });

            const $newContent = $(responseHTML).find('#main-collection-product-grid');
            $('#main-collection-product-grid').html($newContent.html());

            const $newFilterForm = $(responseHTML).find('#CollectionProductFiltersHead');
            if ($newFilterForm && $newFilterForm.length) {
                $('#CollectionProductFiltersHead').html($newFilterForm.html());
            }

            const $newFilterSidebar = $(responseHTML).find('[data-collection-sidebar-filters]');
            if ($newFilterSidebar && $newFilterSidebar.length) {
                $('[data-collection-sidebar-filters]').html($newFilterSidebar.html());
            }

            const $newFilterAside = $(responseHTML).find('.js-col-filter-sidebar');
            if ($newFilterAside && $newFilterAside.length) {
                $('.js-col-filter-sidebar').html($newFilterAside.html());
            }

            const $newFilter = $(responseHTML).find('#CollectionProductFilters'); 
            if ($newFilter && $newFilter.length) {
                $('#CollectionProductFilters').html($newFilter.html());
            }       
        
            const syntheticEvent = new Event("CollectionUpdated", {
                bubbles: true,
                cancelable: false
            });
            document.dispatchEvent(syntheticEvent);
            
            $('.body-loader').removeClass('active');
            $('body').removeClass('pointer-events-none');
            
        } catch (err) {
            console.error('fetchCollection failed:', err);
            throw err;
        }
        
        $('.body-loader').removeClass('active');
        $('body').removeClass('pointer-events-none');

  });

  // Optional: initial sync if it exists on load
  $('[data-collection-filters-price-range]').each(function () {
    const $wrap = $(this);
    const els = getEls($wrap);
    if (els.$minSlider.length && els.$maxSlider.length) {
      setValues($wrap, els.$minSlider.val(), els.$maxSlider.val());
    }
  });



}); 